module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAALCAYAAACd1bY6AAABaklEQVQokW3TT4gOUBQF8B9pksUos1IkoRSlUS+TP7ETZSNFNCtSMxlkI0lJDUkSM4piIbKzpzSSifpeSM1iplhqbKQslBXd6Q6vrzmr917vnnveuect6nQ6FsB2HMNubEAPfmMar/AE76OslPKvenEXz2ZM4CV6cQ07sB67cBsr8Q7PsbEtbsmGEDKnsBqDuT6PZziDtziCNfiKD7XWE91kV3EF+3Aa37NrFP/COJblfhVmcRyHcbPWOhok4dllBPsefG6U3sfyVDKPiXzixeZsS9pyL5RdSrKWKLAulbSYxNr2oJTyCSNhR5DdxYM0ucWXnGqLnd1Na62hbAznlqSxS1P+IbzOe7dy/I/wBvuxCUcbrgN4jNFSyngo+4OTuI4XuIO+zFQoC+NP4ScG8C3j8RBPMVxKuTE/gFZ1f0remnGILM3gB1ZkDvfiYDY+W0oJO+YQz2zxMX2JoMYPuLDAD4iJbsu7/4G/NEdbDgctiZcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/xsmm.png
// module id = h1QC
// module chunks = 1